import { useRef } from "react";
const compareObjects = (a, b) => {
  if (a === b) {
    return true;
  }
  const aEntries = Object.entries(a);
  if (aEntries.length !== Object.keys(b).length) {
    return false;
  }
  for (const [key, val] of aEntries) {
    if (!(key in b) || b[key] !== val) {
      return false;
    }
  }
  return true;
};
const useObjectMemo = (value) => {
  const valueRef = useRef(value);
  if (!compareObjects(valueRef.current, value)) {
    valueRef.current = value;
  }
  return valueRef.current;
};
export {
  useObjectMemo
};
//# sourceMappingURL=useObjectMemo.js.map
